import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SectionWrapper = styled.section`
  padding: 4rem 0;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => theme.colors.background.paper};
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 3rem;
  overflow: hidden;
  
  @media (max-width: 1024px) {
    padding: 0 2rem;
  }
`;

const Title = styled.p`
  text-align: center;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 2rem;
`;

const LogoRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    gap: 2rem;
  }
`;

const LogoPlaceholder = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text.tertiary};
  opacity: 0.7;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

const TrustSection = () => {
    return (
        <SectionWrapper>
            <Container>
                <Title>Trusted By Industry Leaders</Title>
                <LogoRow>
                    {['HealthTech', 'MediCare', 'FutureLife', 'GlobalHealth', 'InnovateMed'].map((name, i) => (
                        <LogoPlaceholder key={i}>{name}</LogoPlaceholder>
                    ))}
                </LogoRow>
            </Container>
        </SectionWrapper>
    );
};

export default TrustSection;
